module.exports = __webpack_public_path__ + "img/money.9d6a0001.svg";